import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumbs from 'components/ds/Breadcrumbs'
import styles from './PageHeader.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const PageHeader = ({ title, lede, breadcrumbs, breadcrumbLinkComponent, facts, actions, className, ...rest }) => (
  <header className={cx(styles.header, className)} {...rest}>
    {breadcrumbs && breadcrumbs.length > 0 && (
      <Breadcrumbs items={breadcrumbs} linkComponent={breadcrumbLinkComponent} />
    )}
    <div className={styles.top}>
      <div>
        <h1 className={styles.title}>{title}</h1>
        {lede && <p className={styles.lede}>{lede}</p>}
        {facts && <div className={styles.facts}>{facts}</div>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  </header>
)

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,

  lede: PropTypes.node,
  breadcrumbs: PropTypes.array,
  breadcrumbLinkComponent: PropTypes.elementType,

  facts: PropTypes.node,

  actions: PropTypes.node,
  className: PropTypes.string,
}

export default PageHeader
